<template>
  <div class="p-category container">
    <div class="p-category__body">
      <div class="p-category__content">
        <div ref="news" class="l-section">
          <h2 class="l-section__title-with-hr">
            {{ main_category }}
          </h2>
          <hr>
          <div class="l-section__content">
            <div class="row">
              <a
                v-for="i in newsData.items"
                :key="i.id"
                :href="`/video/${i.id}/`"
                class="m-card col-sm-4 col-6"
                target="_blank"
                rel="noreferrer noopener"
                title="另開視窗連結影音新聞頁"
              >
                <div v-if="i.type !== 'general'" class="e-type--bg m-card__type">
                  <span :class="articleType(i).style" class="e-type">
                    {{ articleType(i).text }}
                  </span>
                </div>
                <LazyImage
                  :src="i.cover"
                  :alt="i.caption"
                  class="m-card__img"
                  width="250"
                  height="131"
                />
                <h3 class="m-card__title m-card--mle-2">
                  {{ i.title }}
                </h3>
              </a>
            </div>
          </div>
        </div>
        <Pagination
          :total-page="newsData.last_page"
          :current-page="newsData.current_page"
          @update="pageChange"
        />
        <!-- 手機側邊欄 -->
        <SideBarForMobile
          :data="{popular: datas.popular}"
          :type="'video'"
        />
        <!-- 手機側邊欄 -->
      </div>
      <!-- 側邊欄 -->
      <SideBar
        :data="{popular: datas.popular, tags: datas.tags}"
        :type="'video'"
      />
      <!-- 側邊欄 -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import articleHelpers from '@/utils/articleHelpers.js'
import Pagination from '@/components/Pagination.vue'
import LazyImage from '@/components/LazyImage.vue'
import SideBar from '@/components/SideBar.vue'
import SideBarForMobile from '@/components/SideBarForMobile.vue'
import scrollToTop from '@/utils/scrollToTop.js'

export default {
  components: {
    Pagination,
    LazyImage,
    SideBar,
    SideBarForMobile
  },
  mixins: [articleHelpers],
  validate({ params, redirect }) {
    if (/^\d+$/.test(params.id) === false) {
      redirect(301, '/')
    }
    return /^\d+$/.test(params.id)
  },
  async asyncData({ $axios, params, route, error }) {
    const api = $axios.defaults.baseURL
    const pageUrl = `${api}/series_sort/${params.id}`
    let newsUrl = `${api}/series_sort/${params.id}/pagination?page=1`
    if (route.query.page) {
      newsUrl = `${api}/series_sort/${params.id}/pagination?page=${route.query.page}`
    }

    try {
      const { data } = await $axios.$get(pageUrl)
      const { data: newsData } = await $axios.$get(newsUrl)
      return {
        datas: data,
        newsData,
        main_category: `${data.series_sort.title} | CTWANT`
      }
    } catch (e) {
      console.error('Series-sort', {
        code: e.response.data.code,
        message: e.response.data.message,
        method: e.response.config.method,
        url: e.response.config.url
      })
      error({ statusCode: 404 })
    }
  },
  data() {
    return {
      datas: null,
      newsData: null,
      main_category: '',
      pageScrollTop: 0
    }
  },
  head() {
    const hostAndNeedBackslashPath = this.HOST + (this.$route.path.substr(this.$route.path.length - 1) === '/' ? this.$route.path : `${this.$route.path}/`)
    const websiteCategory = {
      '@context': 'http://schema.org',
      '@type': 'Website',
      author: {
        '@type': 'Person',
        name: 'CTWANT'
      },
      creator: {
        '@type': 'Person',
        name: 'CTWANT'
      },
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': hostAndNeedBackslashPath
      },
      publisher: {
        '@type': 'Organization',
        name: 'CTWANT',
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.ctwant.com/images/dist/logo.png'
        }
      },
      dateCreated: this.$config.companyCreatedTimeZone,
      datePublished: this.$config.companyCreatedTimeZone,
      dateModified: this.newsData.items.length > 0 ? this.newsData.items[0].publish_at_time_zone ? this.newsData.items[0].publish_at_time_zone : '' : '',
      headline: this.main_category,
      name: this.main_category,
      url: hostAndNeedBackslashPath,
      keywords: this.datas.tags ? this.datas.tags.slice(0, 10).join() : '',
      description: this.datas.tags ? `相關標籤: ${this.datas.tags.slice(0, 10).join()}` : ''
    }
    const itemListCategory = {
      '@context': 'http://schema.org',
      '@type': 'ItemList',
      itemListElement: this.newsData.items.map((item, index) => {
        return {
          '@type': 'ListItem',
          position: index + 1,
          name: item.title,
          image: item.cover,
          url: `${this.HOST}/video/${item.id}`
        }
      }).slice(0, 5)
    }
    return {
      title: this.main_category,
      meta: [
        { hid: 'ogUrl', property: 'og:url', content: hostAndNeedBackslashPath },
        { hid: 'ogTitle', property: 'og:title', content: this.main_category },
        { hid: 'seriesSortPublished_time', name: 'pubdate', property: 'seriesSort:published_time', itemprop: 'datePublished', content: this.$config.companyCreatedTimeZone },
        { hid: 'seriesSortModified_time', name: 'lastmod', property: 'seriesSort:modified_time', itemprop: 'dateModified', content: websiteCategory.dateModified }
      ],
      link: [
        { hid: 'alternate', rel: 'alternate', hreflang: 'zh-Hant', href: hostAndNeedBackslashPath },
        { hid: 'canonical', rel: 'canonical', href: hostAndNeedBackslashPath }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        { innerHTML: JSON.stringify(websiteCategory), type: 'application/ld+json' },
        { innerHTML: JSON.stringify(itemListCategory), type: 'application/ld+json' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'HOST',
      'WIDTH_PAD',
      'screenWidth'
    ])
  },
  watchQuery: true,
  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch('ad/displayAd')
      this.$store.dispatch('ad/registerAndDisplayPopupAd', { type: this.main_category })
      this.$gtm.push({
        event: 'domMounted',
        pageUrl: this.$route.fullPath,
        pageTitle: this.main_category,
        pageCategory: this.main_category
      })
    })
  },
  updated() {
    if (this.$route.query.page) {
      this.scrollToNews()
    }
  },
  methods: {
    pageChange(page) {
      this.$store.dispatch('ad/displayAd')
    },
    scrollToNews() {
      const offset = 100
      this.pageScrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop
      const newsPos = this.$refs.news.getBoundingClientRect().top + this.pageScrollTop

      if (this.pageScrollTop > newsPos) {
        scrollToTop(newsPos - offset, 1500, 'easeOutSine')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/pages/_category';
</style>
